import { Refresh } from "@mui/icons-material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useIsMaintenanceQuery } from "../features/maintenance-check-point/queries/useIsMaintenanceQuery";

const MaintenanceView = () => {
  const { refetch, isRefetching } = useIsMaintenanceQuery();
  return (
    <Box
      component="main"
      sx={{
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pb: 10,
        gap: 2,
      }}
    >
      <ConstructionIcon
        aria-hidden="true"
        sx={(theme) => ({
          fontSize: theme.typography.pxToRem(100),
        })}
      />
      <Typography component="h1" variant="h2">
        Trwają prace serwisowe
      </Typography>
      <Typography component="h2" variant="h5">
        Przepraszamy, strona chwilowo nieczynna.
      </Typography>
      <Button
        variant="contained"
        onClick={() => refetch()}
        disabled={isRefetching}
        startIcon={
          isRefetching ? <CircularProgress size="1rem" /> : <Refresh />
        }
      >
        Spróbuj ponownie
      </Button>
    </Box>
  );
};

export default MaintenanceView;
